<script>
export default {
    name: "ViewCombinedInvoice",
    data() {
    return { 
        main: 0,
      patient: {},
      detailinvoiceno:this.invoice.receiptnInvoiceNo,
      footerMessage: {},
      visitDetail:[],
      insuranceDetails:{}, 
      otherInsuranceDetails:{},
    age:0,
nationalId:0,  dateofAdmission:'',
dateofDischarge:'',
ward:'',
bed:'', 
    };
  },
    props: {

        showModal: Boolean,
        invoice: Object,
        combinedInvoice: Object, 
        organizations: Array,
    },

    computed: {

        totalAmount() {

if(!this.combinedInvoice.combinedPaymentnInvoiceDetails.length) return 0;
this.getPatientVisitDetails(this.invoice.visitNo);
return this.combinedInvoice.combinedPaymentnInvoiceDetails.map(line => parseFloat(line.amount))
    .reduce((sum,amount) => sum+amount);
},
 
        principalDetails() {
            if(!this.main) return 0;

            const orgs = this.organizations.filter(org => org.organizationID == this.main);

            return orgs.length ? orgs[0] : {};
        },

    },
    watch: {

main() {
    
    this.detailinvoiceno=this.invoicenumber();
    if(!this.main) return;

    this.fetchInsuranceDetails();
},
},
    methods: {
        fetchInsuranceDetails() {
             this.$root.loading = true;
            let url = `MasterData/GetSpecificOrganization`;
                url += `?OrganizationId=${this.main}`;

            return this.$http.get(url).then(({data}) => {
                    this.insuranceDetails = data.length ? data[0] : {};
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
        },
        invoicenumber() {

            if(!this.combinedInvoice.combinedPaymentnInvoiceDetails.length) return this.invoice.receiptnInvoiceNo;
            if(!this.main) return this.invoice.receiptnInvoiceNo; 
return (this.combinedInvoice.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID==this.main).map(line => line.detailReceiptnInvoiceNo)[0]);
    
},
        
        printInvoiceOld() {
            let url = `/billing/receipt-combined-payments/print`;
                url += `?patientID=${this.invoice.patientID}`;
                url += `&invoiceNo=${this.invoice.receiptnInvoiceNo}`;
    
            window.open(url, `_blank`, `CombinedInvoice`);
        },
         printInvoice() {
            let url = `/billing/receipt-combined-invoice/print`;
                url += `?patientID=${this.invoice.patientID}`;
                url += `&invoiceNo=${this.invoice.receiptnInvoiceNo}`;
                url += `&organisationId=${this.main}`;
    
            window.open(url, `_blank`, `CombinedInvoice`);
        },
        getPatientVisitDetails(visitNo) {
      let url = `Visits/GetSpecificPatientVisit`;

      return this.$http
        .get(`${url}?VisitId=${visitNo}`)
        .then((response) => {
          this.visitDetail = response.data;
          this.age= this.visitDetail.specificVisitRecord.age;
       this.nationalId= this.visitDetail.specificVisitRecord.nationalid;
      // this.dateofAdmission= this.visitDetail.specificVisitRecord.admissionDate;
//this.dateofDischarge= this.visitDetail.specificVisitRecord.disschargeDate;

this.dateofAdmission= this.invoice.invoicingAdmissionDate||this.visitDetail.specificVisitRecord.admissionDate;
this.dateofDischarge= this.invoice.invoicingDischargeDate||this.visitDetail.specificVisitRecord.disschargeDate;
this.ward= this.visitDetail.specificVisitRecord.ward;
this.bed= this.visitDetail.specificVisitRecord.bed;
        })
        .catch(() => {this.visitDetail=[]});
    },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base"> INVOICE FOR TREATMENT</h5> 
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center">
            <tail-address-header></tail-address-header>
            <div class="w-full flex flex-row p-2 bg-gray-300 mt-2">
                <div class="flex-1 p-tiny">
                      <h5 class="font-bold text-sm uppercase">Date:  {{invoice.txnDate | dateFormat}}</h5>
                </div>
                <div class="flex-1 p-tiny">
                    <h5 class="font-bold text-sm uppercase"> Invoice No: {{ detailinvoiceno }}</h5>  
                </div>
            </div>
            <div class="flex-1">
                    <div class="w-full flex flex-col content-start">
                       
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Invoice To</h5> 
                        </div>
                        <div class="w-1/2 p-tiny">
                            <label for="grid-insurance" class="label-control">Main Insurance</label>
                            <select v-model.number="main" id="grid-insurance" class="input-control input-sm text-xs">
                                <option value="0">select main insurance</option>
                                <option v-for="insurance in combinedInvoice.combinedPaymentnInvoiceDetails" 
                                    :key="insurance.organizationID" 
                                    :value="insurance.organizationID">{{insurance.organization}}</option>
                            </select>
                        </div>
                        <div class="w-1/2 p-tiny">
                            <!-- <label for="grid-insurance" class="label-control"> Insurance</label> -->
                            <h5 class="font-bold text-sm uppercase"> Combine No: {{invoice.receiptnInvoiceNo}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Address: {{insuranceDetails.postalAddress || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Contact: {{insuranceDetails.cellphone || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Scheme: {{otherInsuranceDetails.scheme || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Package: {{otherInsuranceDetails.package || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Bill Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">Name: {{invoice.names}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">MRN:{{invoice.patientID}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">OP: {{invoice.opfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">IP: {{invoice.ipfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">DOB: {{invoice.dob | dateFormat}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Principal Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">
                                Name: {{ principalDetails.patientName }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member No:{{ principalDetails.memberno }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member ID: {{ principalDetails.memberIDNo || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Employer: {{ principalDetails.employer || `-` }}</h5>
                        </div>
                    </div>
                </div>
            <!-- <div class="w-full p-1 text-center my-3">
                <h5 class="font-medium text-base uppercase">INVOICE FOR TREATMENT</h5>
            </div> -->
            <!-- <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1"> -->
                <!-- <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Name: {{ invoice.names}}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">MRN: {{ invoice.patienT_ID || invoice.patientID }}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">IP NO: {{ invoice.ipfileno }}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">OP NO: {{ invoice.opfileno }}</h5>
                </div> -->
                <!-- <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">VisitNO: {{ invoice.visitNo }}</h5>
                </div> -->
                <!-- <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Invoice No: {{ invoice.receiptnInvoiceNo }}</h5>
                </div> -->
                <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Ward: 
               <span class="text-blue-800">{{ ward || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Bed: 
               <span class="text-blue-800">{{bed|| `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Admitted : 
               <span class="text-blue-800">{{ dateofAdmission|dateFormat }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Discharged : 
               <span class="text-blue-800">{{dateofDischarge|dateFormat}}</span></h6>
            </div>
            </div>
                <tail-stamp></tail-stamp>
            
            <!-- </div> -->
            <div class="w-full overflow-auto">
                <table class="table">
                    <thead class="text-sm">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">Date</th>
                             <th class="p-tiny w-1/2">Item</th>
                            <th class="p-tiny flex-1">Bill No</th>
                            <th class="p-tiny flex-1">Qty</th>
                            <th class="p-tiny flex-1">Amount</th>
                            <th class="p-tiny flex-1">Total</th>
                        </tr>
                    </thead>
                    <tbody class="text-xs flex flex-col items-center">
                        <tr class="w-full flex" 
                            v-for="(line, idxm) in combinedInvoice.combinedPaymentnInvoiceItemsDetails" 
                            :key="idxm">
                            <td class="p-tiny flex-1" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">{{ line.txnDate|dateFormat }}</td>
                            <td class="p-tiny w-1/2">{{ line.service }}</td>
                            <td class="p-tiny flex-1">{{ line.billNo }}</td>
                            <td class="p-tiny flex-1">{{ line.quantity }}</td>
                            <td class="p-tiny flex-1">{{ line.charge | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ line.grandTotal | numberFormat }}</td>
                        </tr>
                        
                        <tr class="w-full flex" v-show="main==0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Total Hospital bill: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> <tr class="w-full flex"  v-show="main==0" 
                            v-for="(detail, idx) in combinedInvoice.combinedPaymentnInvoiceDetails" 
                            :key="`${idx}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right">
                                {{ detail.organization }} Ref: {{ detail.detailReceiptnInvoiceNo }}: {{ detail.amount | numberFormat }}
                            </th>
                        </tr>
                        <!-- <tr class="w-full flex"  v-show="main==0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Net Due: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> -->
                        <tr class="w-full flex" v-show="main>0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Total Hospital bill: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> <tr class="w-full flex"  v-show="main>0" 
                            v-for="(detailx, idxx) in combinedInvoice.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID!==main)" 
                            :key="`${idxx}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right">
                                {{ detailx.organization }} Ref: {{ detailx.detailReceiptnInvoiceNo }}: {{ detailx.amount | numberFormat }}
                            </th>
                        </tr><tr class="w-full flex"  v-show="main>0" 
                            v-for="(detailxc, idxxc) in combinedInvoice.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID==main)" 
                            :key="`${idxxc}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right">
                                Net Due:  {{ detailxc.organization }} Ref: {{ detailxc.detailReceiptnInvoiceNo }} : {{ detailxc.amount | numberFormat }}
                            </th>
                        </tr>
                        <!-- <tr class="w-full flex"  v-show="main>0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Net Due: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> -->
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-info btn-sm text-xs rounded mr-6" 
            @click.prevent="printInvoice">
                <i class="fa fa-print"></i> Print</button>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>
